import React from 'react';
import { FlatList } from 'react-native';
import {
  Avatar, Card, Chip, IconButton, List,
} from 'react-native-paper';
import { View } from 'native-base';
import { differenceInMilliseconds } from 'date-fns';
import { computeCategorie, computeWeightBasedOnCategorie } from '../../../utils/utils';
import { navigate } from '../../../utils/navigation';
import { SCREEN_NAMES } from '../../../utils/constant';
import { theme } from '../../Common.style';

function EventParticipantsTab({ event, disabled = true }) {
  const renderItem = ({ item: p }) => (
    <List.Item
      title={`${p.player.firstName} ${p.player.lastName}`}
      description={() => {
        // Compute category and weight based on the event
        const category = computeCategorie(
          new Date(p.player.profile.dateOfBirth),
          event.season,
          event.level,
        );
        const weightCategory = p.player.profile.weights.length
          ? computeWeightBasedOnCategorie(
            p.player.profile.weights[p.player.profile.weights.length - 1].value,
            p.player.profile.gender,
            category[0],
          )
          : '??';

        const { rentals } = p.player;
        let rental;
        if (rentals.length) {
          const eventTime = new Date(event.startAt);
          rental = rentals.reduce((closest, current) => {
            const closestTime = new Date(closest.rentalDate);
            const currentTime = new Date(current.rentalDate);
            if (Math.abs(differenceInMilliseconds(currentTime, eventTime)) < Math.abs(differenceInMilliseconds(closestTime, eventTime))) {
              return current;
            }
            return closest;
          });
        }
        return (
          <View style={{ flexDirection: 'row', gap: 5 }}>
            <Chip>
              {weightCategory}
              {' '}
              kg
            </Chip>
            <Chip>{category[0]}</Chip>
            {rental && (<Chip style={{ backgroundColor: theme.colors.accent }}>{rental.bag.name}</Chip>)}
          </View>
        );
      }}
      right={() => (
        <IconButton
          icon="file-eye"
          onPress={() => {
            navigate(SCREEN_NAMES.PROFILE, { email: p.player.email, tabIndex: 1 });
          }}
        />
      )}
      left={(props) => (p.player.profile.pictureThumbnail
        ? (
          <Avatar.Image
            {...props}
            source={{
              uri: p.player.profile.pictureThumbnail,
            }}
          />
        )
        : (
          <Avatar.Text
            {...props}
            label={`${p.player.firstName[0]}${p.player.lastName[0]}`}
          />
        ))}
    />
  );

  return (
    <Card.Content style={{ flex: 1 }}>
      <FlatList
        data={event?.players}
        renderItem={renderItem}
        keyExtractor={(item) => item.player.id.toString()}
      />
    </Card.Content>
  );
}

export default EventParticipantsTab;
